import apiService from '../utils/apiService';

import {
  GET_MUNICIPALITY_LIST_START,
  GET_MUNICIPALITY_LIST,
  GET_MUNICIPALITY_LIST_ERROR,
  GET_MUNICIPALITY_LIST_BY_PLACE_START,
  GET_MUNICIPALITY_LIST_BY_PLACE,
  GET_MUNICIPALITY_LIST_BY_PLACE_ERROR,
  ADD_MUNICIPALITY,
  ADD_MUNICIPALITY_START,
  ADD_MUNICIPALITY_ERROR,
  UPDATE_MUNICIPALITY,
  UPDATE_MUNICIPALITY_START,
  UPDATE_MUNICIPALITY_ERROR,
  GET_MUNICIPALITY_LIST_PAGEABLE,
  GET_MUNICIPALITY_LIST_PAGEABLE_START,
  GET_MUNICIPALITY_LIST_PAGEABLE_ERROR,
  GET_MUNICIPALITY_FILTER_LIST,
  GET_MUNICIPALITY_FILTER_LIST_ERROR,
  GET_MUNICIPALITY_FILTER_LIST_START,
  CLEAR_MUNICIPALITY_LIST,
} from './types';

import {
  municipalityFindAllPath,
  municipalityFindAllByPlacePath,
  municipalityAddPath,
  municipalityUpdatePath,
  municipalityFindAllPageablePath,
  filterPageablePath,
} from '../constants/apiEndpoints';
import { notificationTypeSuccess } from '../constants/globals';
import { createNotification } from '../utils';

const clearList = () => {
  return {
    type: CLEAR_MUNICIPALITY_LIST,
  };
};

const getMunicipalityListStart = () => {
  return {
    type: GET_MUNICIPALITY_LIST_START,
  };
};
const getMunicipalityListSuccessfully = (data) => {
  return {
    type: GET_MUNICIPALITY_LIST,
    payload: data,
  };
};
const getMunicipalityListUnsuccessfully = (err) => {
  return {
    type: GET_MUNICIPALITY_LIST_ERROR,
    payload: err,
  };
};

const getMunicipalityListPageableStart = () => {
  return {
    type: GET_MUNICIPALITY_LIST_PAGEABLE_START,
  };
};
const getMunicipalityListPageableSuccessfully = (
  data,
  pageNumber,
  totalElements
) => {
  return {
    type: GET_MUNICIPALITY_LIST_PAGEABLE,
    payload: [data, pageNumber, totalElements],
  };
};
const getMunicipalityListPageableUnsuccessfully = (err) => {
  return {
    type: GET_MUNICIPALITY_LIST_PAGEABLE_ERROR,
    payload: err,
  };
};

const getMunicipalityFilterListStart = () => {
  return {
    type: GET_MUNICIPALITY_FILTER_LIST_START,
  };
};
const getMunicipalityFilterListSuccessfully = (
  data,
  pageNumber,
  totalElements
) => {
  return {
    type: GET_MUNICIPALITY_FILTER_LIST,
    payload: [data, pageNumber, totalElements],
  };
};
const getMunicipalityFilterListUnsuccessfully = (err) => {
  return {
    type: GET_MUNICIPALITY_FILTER_LIST_ERROR,
    payload: err,
  };
};

const addMunicipalityStart = () => {
  return {
    type: ADD_MUNICIPALITY_START,
  };
};
const addMunicipalitySuccessfully = (data) => {
  return {
    type: ADD_MUNICIPALITY,
    payload: data,
  };
};
const addMunicipalityUnsuccessfully = (err) => {
  return {
    type: ADD_MUNICIPALITY_ERROR,
    payload: err,
  };
};

const updateMunicipalityStart = () => {
  return {
    type: UPDATE_MUNICIPALITY_START,
  };
};
const updateMunicipalitySuccessfully = (data) => {
  return {
    type: UPDATE_MUNICIPALITY,
    payload: data,
  };
};
const updateMunicipalityUnsuccessfully = (err) => {
  return {
    type: UPDATE_MUNICIPALITY_ERROR,
    payload: err,
  };
};

const getMunicipalityListByPlaceStart = () => {
  return {
    type: GET_MUNICIPALITY_LIST_BY_PLACE_START,
  };
};
const getMunicipalityListByPlaceSuccessfully = (data) => {
  return {
    type: GET_MUNICIPALITY_LIST_BY_PLACE,
    payload: data,
  };
};
const getMunicipalityListByPlaceUnsuccessfully = (err) => {
  return {
    type: GET_MUNICIPALITY_LIST_BY_PLACE_ERROR,
    payload: err,
  };
};

export const findAllMunicipality = () => {
  return (dispatch) => {
    dispatch(getMunicipalityListStart());
    return apiService
      .get(municipalityFindAllPath())
      .then((response) => {
        dispatch(getMunicipalityListSuccessfully(response.data));
      })
      .catch((err) => {
        dispatch(getMunicipalityListUnsuccessfully(err?.response?.data));
      });
  };
};

export const findAllMunicipalityByPlace = (placeId) => {
  return (dispatch) => {
    dispatch(getMunicipalityListByPlaceStart());
    return apiService
      .get(municipalityFindAllByPlacePath(placeId))
      .then((response) => {
        dispatch(getMunicipalityListByPlaceSuccessfully(response.data));
      })
      .catch((err) => {
        dispatch(getMunicipalityListByPlaceUnsuccessfully(err?.response?.data));
      });
  };
};

export const findAllMunicipalityPageable = (pageNumber, pageSize) => {
  return (dispatch) => {
    dispatch(getMunicipalityListPageableStart());
    return apiService
      .get(municipalityFindAllPageablePath(pageNumber, pageSize))
      .then((response) => {
        dispatch(
          getMunicipalityListPageableSuccessfully(
            response.data.content,
            response.data.totalPages,
            response.data.totalElements
          )
        );
      })
      .catch((err) => {
        dispatch(
          getMunicipalityListPageableUnsuccessfully(err?.response?.data)
        );
      });
  };
};

export const createMunicipality = (municipality, callback, messages) => {
  return (dispatch) => {
    dispatch(addMunicipalityStart());
    return apiService
      .post(municipalityAddPath(), municipality)
      .then((response) => {
        dispatch(addMunicipalitySuccessfully(response.data));
        callback();
        createNotification(
          notificationTypeSuccess,
          messages.municipality,
          messages.addMunicipalitySuccessfully
        );
      })
      .catch((err) => {
        dispatch(addMunicipalityUnsuccessfully(err?.response?.data));
      });
  };
};

export const updateMunicipality = (municipality, callback, messages) => {
  return (dispatch) => {
    dispatch(updateMunicipalityStart());
    return apiService
      .post(municipalityUpdatePath(), municipality)
      .then((response) => {
        dispatch(updateMunicipalitySuccessfully(response.data));
        callback();
        createNotification(
          notificationTypeSuccess,
          messages.municipality,
          messages.updateMunicipalitySuccessfully
        );
      })
      .catch((err) => {
        dispatch(updateMunicipalityUnsuccessfully(err?.response?.data));
      });
  };
};

export const findAllMunicipalityFilterPageable = (
  pageNumber,
  pageSize,
  data,
  succesCallback
) => {
  return (dispatch) => {
    dispatch(getMunicipalityFilterListStart());
    return apiService
      .post(filterPageablePath(pageNumber, pageSize), data)
      .then((response) => {
        dispatch(
          getMunicipalityFilterListSuccessfully(
            response.data.content,
            response.data.totalPages,
            response.data.totalElements
          )
        );
        succesCallback();
      })
      .catch((err) => {
        dispatch(getMunicipalityFilterListUnsuccessfully(err?.response?.data));
      });
  };
};

export const clearMunicipalityList = () => {
  return (dispatch) => {
    dispatch(clearList());
  };
};
